<template>
  <transition name="fade">
    <div
      class="modal headimg_box move_box"
      v-if="visible && moveArticleInfo.length > 0"
    >
      <div class="headimg">
        <div class="title msp_icon_close">
          <span
            class="title_name"
            v-if="
              moveArticleType === 'oneArticleMove' ||
              moveArticleType === 'batchArticleMove'
            "
          >移动</span>
          <span
            class="title_name"
            v-if="
              moveArticleType === 'saveAsOther' ||
              moveArticleType === 'saveMoreAsOther'
            "
          >选择另存文件夹</span>

          <span
            class="title_name"
            v-if="
              moveArticleType === 'saveAsOtherV2'
            "
          >选择投稿文件夹</span>

          <span
            class="title_name"
            v-if="moveArticleType === 'batchArticleRestore'"
          >还原</span>

          <span
            class="iconfont el-icon-close"
            @click.stop="closeBox()"
          ></span>
        </div>
        <el-scrollbar class="move_content masp_repo_tree">
          <savetree
            :hightLight="hightLight"
            :showCheckbox="showCheckbox"
            ref="moveTreeRef"
            :checkStrictly="checkStrictly"
            @checkChangeFolder="checkChangeFolder"
            @checkChangeFolderList="checkChangeFolderList"
          ></savetree>
        </el-scrollbar>

        <div class="headimg_buttom">
          <el-button @click.native="closeBox()">取消</el-button>
          <el-button
            type="primary"
            style="margin-left: 20px"
            @click.native="sureMoveArticle()"
            v-if="!isLoading"
          >确定</el-button>
          <el-button
            type="primary"
            style="background: #ccc; color: #fff"
            v-if="isLoading"
          >加载中</el-button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import * as api from "../../../api";
import axios from "axios";
import savetree from "../repotree/savetree";
import logsMixins from "../../../mixins/logs";
export default {
  name: "movebox",
  data () {
    return {
      visible: false,
      currentChoiceFolder: "",
      moveArticleInfo: "",
      moveArticleType: "",
      currentChoiceFolderList: [],
      isLoading: false,
      showCheckbox: true,
      hightLight: true,
    };
  },
  mixins: [logsMixins],
  mounted () {
    this.$root.eventHub.$on("setMoveArticleModel", (data, type) => {
      this.visible = true;
      this.$nextTick(() => {
        this.$refs.moveTreeRef.getMansuriptData(data);
      });

      this.moveArticleInfo = data;
      this.moveArticleType = type;
    });
  },
  destroyed () {
    this.$root.eventHub.$off("setMoveArticleModel");
  },
  components: {
    savetree,
  },
  computed: {
    checkStrictly () {
      if (
        this.moveArticleType === "oneArticleMove" ||
        this.moveArticleType === "batchArticleMove" ||
        this.moveArticleType === "batchArticleRestore"
      ) {
        return true;
      } else {
        return true;
      }
    },
  },
  methods: {
    closeBox () {
      this.visible = false;
    },
    checkChangeFolder (data) {
      this.currentChoiceFolder = data;
    },
    checkChangeFolderList (data) {
      this.currentChoiceFolderList = data;
    },
    getOperateType () {
      return this.moveArticleType;
    },
    getMoveArticleInfo () {
      return this.moveArticleInfo;
    },
    sureMoveArticle () {
      if (this.currentChoiceFolder || this.currentChoiceFolderList.length > 0) {
        if (
          this.moveArticleType === "oneArticleMove" ||
          this.moveArticleType === "saveAsOther" ||
          this.moveArticleType === "saveAsOtherV2" ||
          this.moveArticleType === "batchArticleRestore"
        ) {
          var params = {};
          var url = "";
          var successMessage = "";
          var errorMessage = "";
          if (this.moveArticleType === "oneArticleMove") {
            params = {
              // 必须字段：  参数
              list_id: [this.moveArticleInfo[0].id], // 文章ID集合
              target_id_repo: this.currentChoiceFolder[0].id_repo, //目标库id
              target_id_folder: this.currentChoiceFolder[0].id, //目标文件夹id
            };
            url = _API_ + "api/article/utils/move_article";
            successMessage = "移动成功";
            errorMessage = "移动失败，请稍后重试";
          } else if (
            this.moveArticleType === "saveAsOther" ||
            this.moveArticleType === "saveAsOtherV2"
          ) {
            var ids = [];
            for (var i = 0; i < this.currentChoiceFolderList.length; i++) {
              if (!this.currentChoiceFolderList[i].flag_repo) {
                ids.push(this.currentChoiceFolderList[i].id);
              }
            }
            params = {
              // 必须字段：  参数
              id_articles: [this.moveArticleInfo[0].id], // 必须字段： 稿件id
              folder_ids: ids, //另存到的文件夹的 ID
            };
            url =
              _API_ +
              "api/article/utils/article_save_news?saveType=" +
              this.moveArticleType;
            successMessage = "操作成功!";
            errorMessage = "操作失败，请稍后重试!";
          } else if (this.moveArticleType === "batchArticleRestore") {
            var articleIds = [];
            for (var i = 0; i < this.moveArticleInfo.length; i++) {
              articleIds.push(this.moveArticleInfo[i].id);
            }
            params = {
              // 必须字段：  参数
              list_id: articleIds, // 文章ID集合
              id_repo: this.currentChoiceFolder[0].id_repo, //目标库id
              id_folder: this.currentChoiceFolder[0].id, //目标文件夹id
            };
            url = _API_ + "api/article/trash/restore_trash_article";
            successMessage = "还原成功";
            errorMessage = "还原失败，请稍后重试";
          }

          var option = {
            ...this.$store.getters.baseOption,
            params: params,
          };
          this.isLoading = true;
          api
            ._post(url, option)
            .then((resp) => {
              if (resp.code == 200) {
                this.$notify.success({
                  title: "成功",
                  message: successMessage,
                });
                this.getOperateLogs(this.moveArticleInfo[0].id);
                if (this.moveArticleType === "oneArticleMove") {
                  this.$root.eventHub.$emit(
                    "deleteMoveArticle",
                    this.moveArticleInfo[0]
                  );
                } else if (this.moveArticleType === "batchArticleRestore") {
                  for (var j = 0; j < this.moveArticleInfo.length; j++) {
                    this.$root.eventHub.$emit(
                      "deleteRecycleArticle",
                      this.moveArticleInfo[j]
                    );
                  }
                }
                this.visible = false;
              } else {
                // this.$notify.error({
                //   title: "失败",
                //   message: errorMessage,
                // });
                console.log(errorMessage)
              }
              this.isLoading = false;
            })
            .catch((error) => {
              console.log(error);
              // this.$notify.error({
              //   title: "失败",
              //   message: errorMessage,
              // });
              this.isLoading = false;
            });
        } else if (this.moveArticleType === "batchArticleMove") {
          this.$root.eventHub.$emit(
            "batchoperateModel",
            this.moveArticleInfo,
            "batchOperateMoveArticle",
            this.currentChoiceFolder
          );
        } else if (this.moveArticleType === "saveMoreAsOther") {
          this.$root.eventHub.$emit(
            "batchoperateModel",
            this.moveArticleInfo,
            "batchOperateSaveAsArticle",
            this.currentChoiceFolderList
          );
        }
      } else {
        this.$notify.warning({
          title: "警告",
          message: "请选择文件夹",
        });
      }
    },
  },
  watch: {
    moveArticleInfo () {
      if (this.moveArticleInfo.length === 0) {
        this.visible = false;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='stylus' scoped>
.headimg_box
  .headimg
    position relative
    width 586px
    height 640px
    border-radius 6px
    background #fff
    .title
      clear both
      box-sizing border-box
      padding 0 14px 0 14px
      height 48px
      border-bottom 1px solid #E4E7ED
      .title_name
        span-medium-title()
        float left
        line-height 48px
      .iconfont
        float right
        font-size 22px
        line-height 48px
        cursor pointer
    .move_content
      box-sizing border-box
      margin-top 10px
      padding-left 14px
      height 510px
    .headimg_buttom
      position absolute
      bottom 20px
      left 0
      display flex
      justify-content center
      box-sizing border-box
      width 100%
      border-radius 0 0 6px 6px
      button
        width 74px
        height 28px
        center()
        line-height 0
</style>
